import { CollectionStatistics } from 'src/features/white-labels/ocean/collection/components/collection-statistics';
import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledAuthor = styled(Typography)`
    color: ${({ theme }) => theme.colors.warmBlack};
    padding: 0 10px;

    & span {
        margin-right: 5px;
        color: ${({ theme }) => theme.colors.blue};
    }

    ${media.sm`
        font-size: 16px; 
        padding: 0 20px;
  `}

    ${media.md`
        padding: 0 80px;
  `}
`;

export const StyledCollectionStatistics = styled(CollectionStatistics)`
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 0 10px;
    grid-gap: 6px;

    ${media.sm`
        width: fit-content;
        margin: 0;
        padding: 0;
        background-color: ${({ theme }: any) => theme.colors.white};
        border: 6px solid ${({ theme }: any) => theme.colors.white};
  `}

    ${media.md`
      width: 400px;
  `}
`;

export const StyledCollectionHeaderWrapper = styled.div`
    position: relative;

    & > button {
        position: absolute;
        top: 20px;
        right: 20px;
    }
`;

export const StyledCollectionBottomWrapper = styled.div`
    background: ${({ theme }: any) => theme.colors.gs100};
    margin: -84px 10px 10px;
    padding: 20px 10px;

    ${media.sm`
        margin-top: -135px;
        padding: 60px 10px 40px;
    `}

    ${media.md`
        margin-top: -158px;
        padding: 40px 10px;
    `}
`;
